import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
const Ctx = createContext();
export const useToast = () => useContext(Ctx);
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const counter = useRef(0);
  const add = useCallback((msg, type) => {
    const id = `t_${Date.now()}_${++counter.current}`;
    setToasts(p => [...p, { id, msg, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 4000);
  }, []);
  const val = { success: m => add(m, 's'), error: m => add(m, 'e'), info: m => add(m, 'i') };
  return (<Ctx.Provider value={val}>
    {children}
    <div className="toast-container">
      {toasts.map(t => (<div key={t.id} className={`toast toast-${t.type}`}>
        <span style={{ fontSize: '1.1rem' }}>{t.type === 's' ? '✅' : t.type === 'e' ? '❌' : '💡'}</span>
        <span style={{ fontSize: '0.82rem' }}>{t.msg}</span>
      </div>))}
    </div>
  </Ctx.Provider>);
}
